import React, { useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import * as lib from '~/dependencies';
import api from '~/services';
import messagesToast from '~/validations/messagesNotifications';
import { Container, BtnSubmit, ButtonCancel } from './styles';

export default function Report({ userInfo }) {
  // STATES
  const [reportText, setReportText] = useState('');
  const [loading, setLoading] = useState(false);

  // HOOKS
  const { t } = lib.useTranslation();

  async function submitReport() {
    const { userAgent, userAgentData } = navigator;
    const machineId = userAgent.match(/machineId:(.*?)%/i) || 'Unknown';
    const OS = userAgentData?.platform || 'Unknown';
    const desktopVer = userAgent.match(/desktopVersion:(.*?)%/i) || 'Unknown';

    setLoading(true);

    const deviceParam = {
      'Account: ': userInfo.account_id,
      'Extension: ': userInfo.user_extension,
      'machineId: ': machineId,
      'OS: ': OS,
      'desktopVer: ': desktopVer,
    };

    const data = {
      device_param: deviceParam,
      user: {
        account_name: userInfo.account_name,
        user_name: userInfo.user_name,
      },
      message: {
        time: new Date(),
        body: reportText,
      },
    };
    try {
      await api.feedback.post.sendFeedback(data);
      lib.ToastMessage('success', messagesToast().FEEDBACK.success);
      setLoading(false);
      setReportText('');
    } catch (error) {
      lib.ToastMessage('error', messagesToast().FEEDBACK.error);
    }
  }

  return (
    <Container>
      <span className="title">
        {t('screens.configuration.components.report.title')}
      </span>
      <textarea
        disabled={loading}
        value={reportText}
        className="reportInfo"
        onChange={text => setReportText(text.target.value)}
      />
      <div className="actions">
        <ButtonCancel
          type="button"
          onClick={() => setReportText('')}
          hide={reportText.length === 0}>
          {t('screens.configuration.components.report.cancel')}
        </ButtonCancel>
        <BtnSubmit
          disabled={loading || reportText.length === 0}
          onClick={() => submitReport()}>
          {loading ? (
            <CircularProgress className="loading" />
          ) : (
            <span>{t('screens.configuration.components.report.send')}</span>
          )}
        </BtnSubmit>
      </div>
    </Container>
  );
}

Report.defaultProps = {
  userInfo: [],
};

Report.propTypes = {
  userInfo: lib.PropTypes.instanceOf(Object),
};
